import ClassicBuilder from './classic-builder';
import PlayerBuilderInterface from 'components/organisms/players-to-exchange/available-players/player-builder-interface';
import BuilderInterface from 'components/organisms/players-to-exchange/available-players/builder-interface';

export default class BuilderFactory implements PlayerBuilderInterface {
    createClassicBuilder(sportConfig): BuilderInterface {
        return new ClassicBuilder(sportConfig);
    }

    createTiersBuilder(sportConfig): BuilderInterface | never {
        throw new Error('Not Implemented');
    }

    createShowDownBuilder(sportConfig): BuilderInterface | never {
        throw new Error('Not Implemented');
    }

    createSingleGameBuilder(sportConfig): BuilderInterface | never {
        throw new Error('Not Implemented');
    }
}
